import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '@huge-monorepo/shared/modules';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'huge-monorepo-teltonika-ip-list-modal',
  standalone: true,
  imports: [CommonModule, MaterialModule],
  templateUrl: './teltonika-ip-list-modal.component.html',
  styleUrl: './teltonika-ip-list-modal.component.scss',
})
export class TeltonikaIpListModalComponent {
  ips: string[] = []
  activeIp: string = ''
  constructor(public dialogRef: MatDialogRef<TeltonikaIpListModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { ips: string[], activeIp: string }) {
    this.ips = data.ips;
    this.activeIp = data.activeIp;
  }

  close() {
    this.dialogRef.close();
  }
}
